import { render } from "./purchaseFile.vue?vue&type=template&id=0e0a5a44"
import script from "./purchaseFile.vue?vue&type=script&lang=js"
export * from "./purchaseFile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__